import useConfigQuery from '@/queries/hooks/useConfigQuery';
import { getOsType, Os } from '@/utils/agent';

export default function useApplyEventId() {
  const { data: config } = useConfigQuery();

  return getOsType() === Os.ANDROID ? config.aosEventId : config.iosEventId;
}
